module.exports = __webpack_public_path__ + "img/imperial-negro.bb215f16.png";